// src/services/useCompaniesService.ts
import { useCallback, useState } from 'react';
import useFetch, { ServiceParams, ServiceResponse } from '../hooks/useFetch';
import EndPoints from '../config/EndPoint';
import { Events } from './useCompaniesService';
import { Passes } from '../models/PassesModel';




const qs = (filters?: Record<string,any>) => {
  if (!filters) return '';
  return Object.entries(filters)
    .filter(([,v]) => v !== undefined && v !== null && v !== '')
    .map(([k,v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join('&');
};

const usePassesService = () => {
  const { doGet, doPost, doPut, doDelete } = useFetch();
  const [fetching, setFetching] = useState<Record<string,boolean>>({});

  // setFetch memoizado
  const setFetch = useCallback((key: string, val: boolean) => {
    setFetching(prev => ({ ...prev, [key]: val }));
  }, []);

  const list = useCallback((filters?: Record<string,any>, events: Events = {}, signal?: AbortSignal) =>
    doGet({
      url: `${EndPoints.PASSES.LIST}${qs(filters) ? `?${qs(filters)}` : ''}`,
      setFetching: v => setFetch('list', v),
      signal,
      ...events
    } as ServiceParams)
  , [doGet, setFetch]);

  const show = useCallback((id: number, events: Events = {}) =>
    doGet({
      url: EndPoints.PASSES.SHOW.replace(':id', String(id)),
      setFetching: v => setFetch('show', v),
      ...events
    } as ServiceParams)
  , [doGet, setFetch]);

  const store = useCallback((payload: Passes, events: Events = {}) =>
    doPost({
      url: EndPoints.PASSES.STORE,
      body: payload,
      setFetching: v => setFetch('store', v),
      ...events
    } as ServiceParams)
  , [doPost, setFetch]);

  const update = useCallback((id: number, payload: Passes, events: Events = {}) =>
    doPut({
      url: EndPoints.PASSES.UPDATE.replace(':id', String(id)),
      body: payload,
      setFetching: v => setFetch('update', v),
      ...events
    } as ServiceParams)
  , [doPut, setFetch]);

  const remove = useCallback((id: number, events: Events = {}) =>
    doDelete({
      url: EndPoints.PASSES.DELETE.replace(':id', String(id)),
      setFetching: v => setFetch('delete', v),
      ...events
    } as ServiceParams)
  , [doDelete, setFetch]);



    const create = useCallback(
      (events: Events = {}) =>
        doGet({
          url: EndPoints.PASSES.CREATE,
          setFetching: v => setFetch('create', v),
          ...events,
        } as ServiceParams),
      [doGet, setFetch]
    );
  
    
    const edit = useCallback(
      (id: number, events: Events = {}) =>
        doGet({
          url: EndPoints.PASSES.EDIT.replace(':id', String(id)),
          setFetching: (v) => setFetch('edit', v),
          ...events,
        } as ServiceParams),
      [doGet, setFetch]
    );

  return { fetching, list, show, store, update, remove, create, edit };
};

export default usePassesService;
